import './waves.svg';
import 'gridstrap/svg-symbols/quotation-mark.svg?sprite';

import './wizard.scss';

import { components } from 'gridstrap/lib/gs-components';
import { GSWizard } from './wizard';
import { GSWizardStep } from './wizard-step';

components.register({
	selector: '.gs-Wizard',
	controller: GSWizard
});

components.register({
	selector: '.gs-Wizard-step',
	controller: GSWizardStep
});
